import { getStore, postStore } from '@/utils/http/http'
import { VZAN_STORE_BASE_URL, LIVEPAY_URL } from '@/utils/http/baseUrl'

// 请求方法封装对象
const areaManagerApi = {
  /**
   * @method GET-根据区域id获取区域信息
   */
  getCurrentRegionInfo(params) {
    return getStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/area-manager/getCurrentRegionInfo`,
      params,
      false
    )
  },
  /**
   * @method POST-负责人区域切换列表展示
   */
  getAmRegionList(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/area-manager/regionList`,
      params,
      false
    )
  },
  /**
   * @method POST-区域负责人-门店列表
   */
  getAmStoreList(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/area-manager/storeList`,
      params,
      false
    )
  },
  /**
   * @method POST-添加客户跟进
   */
  amAddFollowUp(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/area-manager/addFollowUp`,
      params,
      false
    )
  },
  /**
   * @method POST-区域负责人-客户列表导出
   */
  amExportCustomerManageInfo(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/area-manager/exportCustomerManageInfo`,
      params,
      false
    )
  },
  /**
   * @method POST-区域负责人-H5完成商机任务
   */
  amFinishStep(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/area-manager/finishStep`,
      params,
      false
    )
  },
  /**
   * @method POST-区域负责人-客户列表
   */
  getAmCustomerManageInfo(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/area-manager/getCustomerManageInfo`,
      params,
      false
    )
  },
  /**
   * @method POST-区域负责人-客户-详情
   */
  getAmCustomerDetail(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/area-manager/getCustomerDetail`,
      params,
      false
    )
  },
  /**
   * @method POST-区域负责人-门店报表-门店报表-商品统计
   */
  getAmProductStatList(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/area-manager/getProductStatList`,
      params,
      false
    )
  },
  /**
   * @method POST-区域负责人-门店报表-商品统计-聚合
   */
  getAmProductStatSum(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/area-manager/getProductStatSum`,
      params,
      false
    )
  },
  /**
   * @method POST-区域负责人-业绩报表-总览
   */
  getAmTotalOrderPerformance(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/area-manager/getTotalOrderPerformance`,
      params,
      false
    )
  },
  /**
   * @method POST-区域负责人-健康观众列表
   */
  getAmHealthUserList(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/area-manager/healthUserList`,
      params,
      false
    )
  },
  /**
   * @method POST-区域负责人-健康观众列表导出
   */
  amHealthUserListExport(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/area-manager/healthUserListExport`,
      params,
      false
    )
  },
  /**
   * @method POST-区域负责人-所有商机
   */
  amListOpportunity(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/area-manager/listOpportunity`,
      params,
      false
    )
  },
  /**
   * @method POST-区域负责人-用户观看栏目
   */
  amListUserColumn(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/area-manager/listUserColumn`,
      params,
      false
    )
  },
  /**
   * @method POST-区域负责人-H5商机步骤详情
   */
  amOpportunityStepDetail(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/area-manager/opportunityStepDetail`,
      params,
      false
    )
  },
  /**
   * @method POST-区域负责人-业绩报表
   */
  amPageDayOrderPerformanceData(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/area-manager/pageDayOrderPerformanceData`,
      params,
      false
    )
  },
  /**
   * @method POST-区域负责人-客户跟进列表
   */
  amPageFollowUp(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/area-manager/pageFollowUp`,
      params,
      false
    )
  },
  /**
   * @method POST-区域负责人-用户观看栏目
   */
  amUserWatchColumn(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/area-manager/userWatchColumn`,
      params,
      false
    )
  },
  /**
   * @method POST-区域负责人-观看直播
   */
  amWatchRecord(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/area-manager/watchRecord`,
      params,
      false
    )
  },
}

// 命名导出所有方法
export const {
  getCurrentRegionInfo,
  getAmRegionList,
  amStoreList,
  amAddFollowUp,
  amExportCustomerManageInfo,
  amFinishStep,
  getAmCustomerManageInfo,
  getAmCustomerDetail,
  getAmProductStatList,
  getAmProductStatSum,
  getAmTotalOrderPerformance,
  getAmHealthUserList,
  amHealthUserListExport,
  amListOpportunity,
  amListUserColumn,
  amOpportunityStepDetail,
  amPageDayOrderPerformanceData,
  amPageFollowUp,
  amUserWatchColumn,
  amWatchRecord,
} = areaManagerApi

// 默认导出封装对象
export default areaManagerApi
